import React, { Component } from 'react';
import RoutesSwitch from '../../../components/flights/routesSwitch/RoutesSwitch';
import TripsSwitch from '../../../components/flights/tripsSwitch/TripsSwitch';
import FlightsFormDesktop from '../../../components/flights/flightsForm/FlightsFormDesktop';
import PassengersCountersHeader from '../../../components/flights/passengerCounters/PassengerCountersHeader';
import PassengersTabsWrapper from '../common/passengersCounter/PassengersCounterTabsWrapper';
import CalendarDesktopTabs from './calendar/CalendarDesktopTabs';
import Constants from '../../../model/AppConfiguration';
import Dictionary from '../../../model/Dictionary';
import FlightsScreenController from '../FlightsScreenController';
import FlightDesktopScreenProps from './FlightDesktopScreenProps';
import ClassNames from 'classnames';
import './FlightsDesktop.css';
import moment from 'moment';

class FlightsDesktopScreen extends Component {
  static propTypes = FlightDesktopScreenProps;

  constructor (props) {
    super(props);

    let flights = props.flights;
    let firstFlight =
      flights && flights.length ? flights[ 0 ] : { adults: 0, infants: 0, date: moment(new Date()) };
    let secondFlight =
      flights && flights.length ?
        flights[ 1 ] :
        { adults: 0, infants: 0, date: moment(moment(new Date())).add(5, 'days') };
    this.state = {
      flights: flights || [],
      adultsDeparture: firstFlight.adults,
      infantsDeparture: firstFlight.infants,
      adultsArrival: secondFlight ? secondFlight.adults : 0,
      infantsArrival: secondFlight ? secondFlight.infants : 0,
      passengersFormOpen: false,
      selectedPassengersTab: 0,
      calendarOpen: false,
      selectedCalendarTab: 0,
      selectedFlight: {},
    };

    this.handlePassengersTabChange = FlightsScreenController.handlePassengersTabChange.bind(this);
    this.handleCalendarTabChange = FlightsScreenController.handleCalendarTabChange.bind(this);
    this.changePassengerNumber = FlightsScreenController.changePassengerNumber.bind(this);
    this.handleClickOpen = FlightsScreenController.handleClickOpen.bind(this);
    this.handleClose = FlightsScreenController.handleClose.bind(this);
    this.selectDate = FlightsScreenController.selectDate.bind(this);
    this.openCalendar = FlightsScreenController.openCalendar.bind(this);
    this.closeCalendar = FlightsScreenController.closeCalendar.bind(this);
    this.getArrivalDate = FlightsScreenController.getArrivalDate.bind(this);
    this.findRouteById = FlightsScreenController.findRouteById.bind(this);
    this.updateFlightsRoute = FlightsScreenController.updateFlightsRoute.bind(this);
  }

  submitData = step => {
    let general = Object.assign({}, this.props.general);
    general.trip = this.props.selectedTrip;
    this.props.submitFlights(Constants.REQUEST.FLIGHTS, general, this.state.flights, step);
  };

  componentWillReceiveProps (props) {
    const { selectedRoute } = props;
    if (props.flights && this.props.flights && props.flights.length > this.props.flights.length) {
      this.setState({ flights: props.flights });
    }

    if (selectedRoute !== this.props.selectedRoute) {
      this.updateFlightsRoute(selectedRoute, this.props.selectedRoute);
    }
  }

  render () {
    const { selectedRoute, toggleRoutes, selectedTrip, toggleTrips } = this.props;
    const {
      flights,
      passengersFormOpen,
      selectedPassengersTab,
      calendarOpen,
      selectedCalendarTab,
      departureFlight,
      arrivalFlight,
    } = this.state;

    return (
      <div className='row flights'>
        <div
          className={ClassNames({
            'col-8': passengersFormOpen || calendarOpen,
            'col-12': !passengersFormOpen && !calendarOpen,
          })}
        >
          <div className='flights-wrapper'>
            <div className='content'>
              <h1 className='flights'>{Dictionary.flights.title}</h1>
              <RoutesSwitch selectedRoute={selectedRoute} toggleRoutes={toggleRoutes} />
              <TripsSwitch selectedTrip={selectedTrip} toggleTrips={toggleTrips} />
              <div
                className={ClassNames({
                  'desktop-flights-form-wrapper': true,
                  'one-way': selectedTrip && selectedTrip.id === Constants.flights.oneWay,
                })}
              >
                {flights.map((flight, index) => {
                  if (selectedTrip && selectedTrip.id === Constants.flights.oneWay && index > 0) {
                    return null;
                  }
                  return (
                    <FlightsFormDesktop
                      key={`flights-form-desktop-${flight.id}-${index}`}
                      location={this.findRouteById(flight.routeId).departure}
                      adults={flight.adults ? parseInt(flight.adults, 10) : 0}
                      infants={flight.infants ? parseInt(flight.infants, 10) : 0}
                      date={flight.date}
                      openCalendar={() => this.openCalendar(index)}
                      handleClickOpen={() => this.handleClickOpen(index)}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className={ClassNames({
            'col-4': calendarOpen,
            'margin-0': true,
            'padding-0': true,
            'flight-left-container': true,
          })}
          style={{ display: calendarOpen && !passengersFormOpen ? 'block' : 'none' }}
        >
          <CalendarDesktopTabs
            selectedRoute={selectedRoute}
            selectedTrip={selectedTrip}
            flights={flights}
            departureFlight={departureFlight}
            arrivalFlight={arrivalFlight}
            open={calendarOpen}
            selectDate={this.selectDate}
            handleClose={this.closeCalendar}
            handleTabChange={this.handleCalendarTabChange}
            selectedTab={selectedCalendarTab}
          />
        </div>
        <div
          className={ClassNames({
            'col-4': passengersFormOpen && !calendarOpen,
            'margin-0': true,
            'padding-0': true,
            'flight-left-container': true,
          })}
          style={{ display: passengersFormOpen ? 'block' : 'none' }}
        >
          <div>
            <PassengersCountersHeader selectedTrip={selectedTrip} handleClose={this.handleClose} />
            <PassengersTabsWrapper
              selectedRoute={selectedRoute}
              selectedTrip={selectedTrip}
              flights={flights}
              changePassengerNumber={this.changePassengerNumber}
              open={passengersFormOpen}
              handleClose={this.handleClose}
              handleTabChange={this.handlePassengersTabChange}
              selectedTab={selectedPassengersTab}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FlightsDesktopScreen;



// WEBPACK FOOTER //
// ./src/containers/flights/desktop/FlightsDesktopScreen.js